export type JerseySize = "sm" | "md" | "lg" | "xl";

export interface JerseyNumberProps {
  value: number | string;
  size?: JerseySize;
  className?: string;
}

/** md is 2.75rem from 640px up and 1.5rem (sm) on phones, so label-grid rows keep their name room. */
const SIZE_CLASS: Record<JerseySize, string> = {
  sm: "text-2xl",
  md: "text-2xl sm:text-display-md",
  lg: "text-display-lg",
  xl: "text-display-xl",
};

/** Jersey numeral: Barlow Condensed 800 with tabular figures. Large numerals carry the hierarchy. */
export function JerseyNumber({ value, size = "md", className = "" }: JerseyNumberProps) {
  return (
    <span
      className={`inline-block font-display leading-[0.92] font-extrabold tabular-nums text-ink ${SIZE_CLASS[size]} ${className}`}
    >
      {value}
    </span>
  );
}
